// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/es6.number.min-safe-integer.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/es6.number.min-safe-integer.js
// module chunks = 0